export enum ActionTypesProduct {
   UPDATE_COLOR = 'updateColor',
   UPDATE_SIZE = 'updateSize',
   UPDATE_QTY = 'updateQty',
   FINISH_UPDATE = 'finishUpdate',
}